// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table[data-v-62db3068]{table-layout:fixed;width:100%}table th[data-v-62db3068]{vertical-align:middle}", ""]);
// Exports
module.exports = exports;
